import {
  Flex,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import { NumericFormat, PatternFormat } from "react-number-format";
import {
  BLUEMONEDDBUTTONS,
  GRAY_LIGHTER,
  VARIANT,
  WHITE,
} from "../../../../constants/colors";

export default function ValueDropdown({ filtros, setFiltros }: any) {
  const [valor, setValor] = useState({
    valor1: 0,
    valor2: 0,
  });

  const valorminimo = 0;
  const valormáximo = 50000;

  function changeValues(item: any) {
    setValor({ ...valor, valor1: item[0], valor2: item[1] });
    setFiltros({
      ...filtros,
      minValueFilter: item[0],
      maxValueFilter: item[1],
    });
  }

  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        minWidth="100px"
        bgColor={BLUEMONEDDBUTTONS}
        color="white"
        height={"40px"}
        borderRadius={"8px"}
        fontSize={"1.8vh"}
      >
        Valor
      </MenuButton>
      <MenuList minWidth="300px">
        <MenuGroup title={"De"}>
          <MenuItem isDisabled={true}>
            <NumericFormat
              decimalSeparator=","
              decimalScale={2}
              customInput={Input}
              value={Number(filtros.minValueFilter)}
              onChange={(e: any) => {
                setFiltros({
                  ...filtros,
                  minValueFilter: Number(e.target.value.replace(",", ".")),
                });
              }}
            />
            {/* <Input
                            type="text"
                            value={filtros.minValueFilter}
                            onChange={(e: any) => {
                                setFiltros({ ...filtros, minValueFilter: Number(e.target.value) });
                            }}
                        /> */}
          </MenuItem>
        </MenuGroup>
        <MenuGroup title={"Até "}>
          <MenuItem isDisabled={true}>
            <NumericFormat
              decimalSeparator=","
              decimalScale={2}
              customInput={Input}
              value={Number(filtros.maxValueFilter)}
              onChange={(e: any) => {
                setFiltros({
                  ...filtros,
                  maxValueFilter: Number(e.target.value.replace(",", ".")),
                });
              }}
            />
            {/* <Input
                            type="text"
                            value={filtros.maxValueFilter}
                            onChange={(e: any) => {
                                setFiltros({ ...filtros, maxValueFilter: Number(e.target.value) });
                            }}
                        /> */}
          </MenuItem>
        </MenuGroup>
        <MenuGroup
          title={`Valores de: R$ ${filtros.minValueFilter} até: R$ ${filtros.maxValueFilter}`}
        >
          <MenuItem>
            <RangeSlider
              aria-label={["min", "max"]}
              value={[filtros.minValueFilter, filtros.maxValueFilter]}
              step={100}
              min={valorminimo}
              max={valormáximo}
              colorScheme="blue"
              defaultValue={[valorminimo, valormáximo]}
              onChange={(item: any) => {
                changeValues(item);
              }}
            >
              <RangeSliderTrack>
                <RangeSliderFilledTrack />
              </RangeSliderTrack>
              <RangeSliderThumb index={0} />
              <RangeSliderThumb index={1} />
            </RangeSlider>
          </MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
}
